
const parentBackgroundColor: string = "#1C3656";
const parentLightBackgroundColor: string = "#354F84";
const teacherBackgroundColor: string = "#fff1e1";
const institutionColor: string = "#58547B";
const premiumColor: string = "#FFB000";
const darkBlue: string = "#1C3656";

export default {
    darkBlue,
    parentBackgroundColor,
    parentLightBackgroundColor,
    premiumColor,
    teacherBackgroundColor,
    institutionColor
}